if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
  document.querySelectorAll('link[rel~="icon"]').forEach((icon) => {
    icon.setAttribute('href', icon.href.replace('favicon', 'favicon-dark'))
  })
}
